import { getHotjarDataLocalStorage } from "@creditas/home-mf-shared";

const MAX_RETRIES = 10;

function getHotjarData(): Promise<any> {
  let nRetries = 0;

  return new Promise((res) => {
    const getHotjarDataTimeout = () =>
      setTimeout(() => {
        const hotjarData = getHotjarDataLocalStorage();

        if (hotjarData) {
          res(hotjarData);
        } else {
          getHotjarDataTimeout();
        }

        if (nRetries === MAX_RETRIES) res(null);
        nRetries++;
      }, 1000);

    getHotjarDataTimeout();
  });
}

function identifyHotjar({ leadId, ...hotjarData }) {
  setTimeout(() => {
    if (window.hj) {
      window.hj("identify", leadId, hotjarData);
    } else {
      identifyHotjar({ leadId, ...hotjarData });
    }
  }, 1000);
}

export async function initHotjar() {
  const hotjarData = {} as any;

  window.addEventListener(
    "single-spa:routing-event",
    async function routeListener() {
      const hasHotjarData = Object.keys(hotjarData).length > 0;

      if (!hasHotjarData) {
        const data = await getHotjarData();

        if (!data) {
          window.removeEventListener("single-spa:routing-event", routeListener);
          return;
        }

        Object.assign(hotjarData, data);
      }

      identifyHotjar(hotjarData);
    }
  );
}
